<ng-container *ngIf="postalAddresses?.length > 0; else noPostAddress">
    <ng-container *ngFor="let paddress of postalAddresses">
        {{ paddress.id }} {{ paddress.street }} {{ paddress.streetNumber }}
    </ng-container>
</ng-container>
<ng-template #noPostAddress>
    {{ 'common.no-entries' | translate }}
</ng-template>
